export default "__VITE_ASSET__C2ouzC3f__"